import { defineAction, object } from '~/prix'
import communityListAction from './geoCommunityList.action.json' assert { type: 'json' }
// import { communityObject } from '../geoCommunityObject'
// import { z } from 'zod'
// import expression from '~/prix/types/expression'
// import { enumerated } from '~/prix/types/enumerated'

// export const communityExpression = expression(communityObject.shape)

const communityListDefinition = defineAction({
  ...communityListAction,

  // input: z.object({
  //   filter: communityExpression.nullish(),
  //   limit: z.number().min(1).max(200).nullish(),
  //   offset: z.number().nullish(),
  //   orderBy: enumerated({
  //     createdAt: 'Data de criação',
  //     updatedAt: 'Data de atualização',
  //     synchronizedAt: 'Data de sincronização',
  //     id: 'Identificador',
  //     name: 'Nome',
  //   }).nullish(),
  //   order: enumerated({
  //     ascending: 'Ascendente',
  //     descending: 'Descendente',
  //   }).nullish(),
  //   includeDeleted: z.boolean().nullish(),
  //   municipalityId: z.number(),
  // }),
  // output: z.object({ items: z.array(communityObject), count: z.number() }),

  input: object<any>({}),
  output: object<any>({}),
})

export default communityListDefinition
